import requestFile from '@/utils/requestFile'
import request from "@/utils/request";

export function upVehicleLicense(file) {
    var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
    formData.append('file', file); //接口需要传的参数
    return requestFile({
        url: 'api/carInspectionVehicleLicense/upVehicleLicense',
        method: 'post',
        data: formData
    })
}

export function upVehicleLicenseBack(file) {
    var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
    formData.append('file', file); //接口需要传的参数
    return requestFile({
        url: 'api/carInspectionVehicleLicense/upVehicleLicenseBack',
        method: 'post',
        data: formData
    })
}

export function upVehicleLicenseOCR(file) {
    var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
    formData.append('file', file); //接口需要传的参数
    return requestFile({
        url: 'api/carInspectionVehicleLicense/upVehicleLicenseOCR',
        method: 'post',
        data: formData
    })
}

export function upCompulsoryInsurance(file) {
    var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
    formData.append('file', file); //接口需要传的参数
    return requestFile({
        url: 'api/carInspectionVehicleLicense/upCompulsoryInsurance',
        method: 'post',
        data: formData
    })
}

export function getAll() {
    return requestFile({
        url: 'api/carInspectionVehicleLicense',
        method: 'get'
    })
}

export function add(data) {
    return request({
        url: 'api/carInspectionVehicleLicense',
        method: 'post',
        data
    })
}

export default {upVehicleLicenseOCR, upVehicleLicense, upVehicleLicenseBack, upCompulsoryInsurance, getAll, add}
